<template>
  <div :class="platform + '-login-app-wrapper'" class="login-app-wrapper">
    <ConfigProvider v-bind="config" :key="$route.fullPath">
      <RouterView />
    </ConfigProvider>
  </div>
</template>
<script setup lang="ts">
  import { ConfigProvider } from '@aplus-frontend/ui';
  import useConfigProvider from '@/hooks/use-config-provider';
  import { RouterView } from 'vue-router';
  const { config } = useConfigProvider();
  const { pathname } = window.location;
  let platform;
  if (pathname.includes('admin.html')) {
    platform = 'admin';
  } else {
    platform = 'user';
  }
</script>
<style lang="less" scoped>
  .login-app-wrapper {
    width: 100vw;
    height: 100vh;
  }
</style>
